const SideHeader = ({ title }) => {
    return (
        <header className="header side-header">
            <h1>{title}</h1>
        </header>
    )
}

export default SideHeader
